<template>

  <el-card class="_main" shadow="always">
    <!-- <el-main class="_main">
    <slot></slot>
  </el-main> -->
    <slot></slot>
  </el-card>
</template>
<script setup>
import { UserInfoStore, TagviewsStore, themeStore } from "@/stores/index.js";
const theme_store = themeStore();
defineOptions({
  name: "Main",
});
</script>
<style lang="scss" scoped>
._main{
  overflow: visible !important;
  min-height: calc(100% - 50px);
  box-sizing: border-box;
}
</style>
